export default __webpack_public_path__ + "static/banner-four-shape2-a26c09f3c681c8f1f30ee0c4b4c45e8a.png";